import React, { useEffect, useState } from "react";
import {
  Container,
  Dialog,
  Grid,
  FormControl,
  InputLabel,
  Select,
  Typography,
} from "@material-ui/core";
import { CorreosButton } from "../../../components/CorreosButton/CorreosButton";
import { CommonStyles } from "../../../commons/CommonStyles";
import { DialogStyles } from "../../CommonComponents/Dialogs/DialogStyles";
import { useTranslation } from "react-i18next";
import { checkIsNullUndefined } from "../../../commons/Utils";
import { backToLogin } from "../../../services/Commons";

export function DialogEnterprise(props) {
  const { enterprises, manageEnterpriseLogin, openDirectly } = props;
  const commonClasses = CommonStyles();
  const dialogClasses = DialogStyles();
  const { t } = useTranslation();

  const [enterprise, setEnterprise] = useState("");
  const [enterprisesWithSub, setEnterprisesWithSub] = useState([]);
  const [enterprisesWithoutSub, setEnterprisesWithoutSub] = useState([]);
  const [open, setOpen] = useState(openDirectly);
  const [withButtons, setWithButtons] = useState(true);

  useEffect(() => {
    selectView();
  }, [enterprises]);

  const selectView = () => {
    setEnterprise(enterprises[0]?.id);
    let auxWithoutSub = enterprises.filter((empresa) => !empresa.hasSub);
    let auxWithSub = enterprises.filter((empresa) => empresa.hasSub);
    setEnterprisesWithoutSub(auxWithoutSub);
    setEnterprisesWithSub(auxWithSub);
    setWithButtons(enterprises?.length <= 5);
  };

  const handleCancel = () => {
    backToLogin();
    setOpen(false);
  };

  const handleNext = (auxEnterpriseId) => {
    let auxEnteprise = enterprises.find((empresa) => empresa.id == auxEnterpriseId);
    manageEnterpriseLogin(auxEnteprise.id, auxEnteprise.idRol, auxEnteprise.isOrganization);
    setOpen(false);
  };

  const handleChange = (event) => {
    setEnterprise(event.target.value);
  };

  const mountButtons = () => {
    return (
      <Grid item xs={12}>
        {enterprisesWithSub?.length > 0 ? (
          <>
            <Typography
              variant="subtitle1"
              className={commonClasses.dialogTitleText}
            >
              {t("chooseEnterpriseDialogText1")}
              <b>{t("chooseEnterpriseDialogSubscribed")}</b>
              {t("chooseEnterpriseDialogText2")}
            </Typography>
            {enterprisesWithSub.map((empresa) => {
              return buttonGenerator(empresa);
            })}
          </>
        ) : null}
        {enterprisesWithoutSub?.length > 0 ? (
          <>
            <Typography
              variant="subtitle1"
              className={commonClasses.dialogTitleText}
              style={{ marginTop: enterprisesWithSub?.length > 0 ? "1em" : 0 }}
            >
              {t("chooseEnterpriseDialogText1")}
              <b>{t("chooseEnterpriseDialogNoSubscribed")}</b>
              {t("chooseEnterpriseDialogText2")}
            </Typography>
            {enterprisesWithoutSub.map((empresa) => {
              return buttonGenerator(empresa);
            })}
          </>
        ) : null}
      </Grid>
    );
  };

  const buttonGenerator = (empresa) => {
    return (
      <Grid key={empresa.id} item xs={12}>
        <CorreosButton
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => handleNext(empresa.id)}
          style={{ marginTop: "0.75em" }}
        >
          {checkIsNullUndefined(empresa.companyName) ? empresa.tradeName : empresa.companyName}
        </CorreosButton>
      </Grid>
    );
  };

  const selectGenerator = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          className={commonClasses.dialogTitleText}
          style={{ marginBottom: "1em" }}
        >
          {t("chooseEnterpriseDialogSelectText")}
        </Typography>
        <FormControl variant="filled" fullWidth color="secondary" className={commonClasses.inputsStyle} >
          <InputLabel label={t("Empresa")} color="secondary">
            {t("Empresa")}
          </InputLabel>
          <Select
            native
            color="secondary"
            value={enterprise}
            onChange={handleChange}
            label={t("Empresa")}
          >
            {enterprises.map((empresa) => {
              return (
                <option key={empresa.id} value={empresa.id}>
                  {isSubscribed(empresa.id)}{checkIsNullUndefined(empresa.companyName) ? empresa.tradeName : empresa.companyName}
                </option>
              );
            })}
          </Select>
        </FormControl>
      </>

    );
  };

  const isSubscribed = (entepriseId) => {
    let auxEnterprise = enterprisesWithSub.find((empresa) => empresa.id == entepriseId);
    let auxText = !checkIsNullUndefined(auxEnterprise) ? "* " : "";
    return auxText;
  };

  return (
    <Grid>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={open}
        PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
      >
        <Container className={dialogClasses.dialogTitle}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                className={dialogClasses.dialogTitleText}
              >
                {t("chooseEnterpriseDialogTitle")}
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container className={dialogClasses.dialogContainer}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              {withButtons
                ? mountButtons()
                : selectGenerator()}
            </Grid>
            <Grid
              container
              item
              xs={12}
              className={dialogClasses.dialogButtonContainer}
            >
              <Grid item xs={6}>
                <CorreosButton
                  color="secondary"
                  className={dialogClasses.dialogButtonLeft}
                  onClick={handleCancel}
                >
                  {t("cancel")}
                </CorreosButton>
              </Grid>
              {!withButtons && (
                <Grid item xs={6}>
                  <CorreosButton
                    variant="contained"
                    color="primary"
                    className={dialogClasses.dialogButtonRight}
                    onClick={() => handleNext(enterprise)}
                  >
                    {t("accept")}
                  </CorreosButton>
                </Grid>)}
            </Grid>
          </Grid>
        </Container>
      </Dialog>
    </Grid>
  );
}
